import { waLink } from "@/lib/brand";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="fixed z-50 bottom-24 lg:bottom-6 right-6 w-14 h-14 rounded-full grid place-items-center shadow-lg shadow-black/20 transition-transform hover:scale-105"
      style={{ background: "#25D366", color: "white" }}
    >
      <MessageCircle size={24} />
      <span className="absolute -top-1 -right-1 w-3.5 h-3.5 rounded-full bg-[#FF6B35] ring-2 ring-white animate-pulse" />
    </a>
  );
}
